import React from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import LegendsLeague from '@assets/images/icon/legends-league.svg'
import CCL from '@assets/images/icon/ccl.svg'
import MysuruWarrious from '@assets/images/icon/mysuru-warrious.svg'
import DelhiDaredevils from '@assets/images/icon/delhi-daredevils.svg'
import SportsTogether from '@assets/images/icon/sports-together.svg'
import SportzInteractive from '@assets/images/icon/sportz-interactive.svg'
import SaurashtraLeague from '@assets/images/icon/saurashtra-league.svg'
import RR from '@assets/images/icon/rr.svg'
import PunjabDeSher from '@assets/images/icon/punjab-de-sher.svg'
import SuperStars from '@assets/images/icon/super-stars.svg'
import StarSports from '@assets/images/icon/star-sports.svg'
import AbuDhabi from '@assets/images/icon/abu-dhabi.svg'
import MaharajaTrophy from '@assets/images/icon/maharaja-trophy.svg'
import RedBull from '@assets/images/icon/red-bull.svg'

function Collaboration() {
  return (
    <div className={`${styles.collaborationWrapper}`}>
      <div>
        <div className={`${styles.collaborationimage}`}>
          <MyImage src={LegendsLeague} width="100" height="100" alt="LegendsLeague" />
        </div>
        <div className={`${styles.collaborationimage}`}>
          <MyImage src={SportsTogether} width="100" height="100" alt="SportsTogether" />
        </div>
        <div className={`${styles.collaborationDouble}`}>
          <div>
            <MyImage src={PunjabDeSher} width="100" height="100" alt="PunjabDeSher" />
          </div>
          <div>
            <MyImage src={SuperStars} width="100" height="100" alt="SuperStars" />
          </div>
        </div>
      </div>
      <div>
        <div className={`${styles.collaborationimage}`}>
          <MyImage src={CCL} width="100" height="100" alt="CCL" />
        </div>
        <div className={`${styles.collaborationDouble}`}>
          <div>
            <MyImage src={SportzInteractive} width="100" height="100" alt="SportzInteractive" />
          </div>
          <div>
            <MyImage src={SaurashtraLeague} width="100" height="100" alt="SportzInteractive" />
          </div>
        </div>
        <div className={`${styles.collaborationimage}`}>
          <MyImage src={StarSports} width="100" height="100" alt="StarSports" />
        </div>
      </div>
      <div>
        <div className={`${styles.collaborationDouble}`}>
          <div>
            <MyImage src={MysuruWarrious} width="100" height="100" alt="MysuruWarrious" />
          </div>
          <div>
            <MyImage src={DelhiDaredevils} width="100" height="100" alt="DelhiDaredevils" />
          </div>
        </div>
        <div className={`${styles.collaborationimage}`}>
          <MyImage src={RR} width="100" height="100" alt="RR" />
        </div>
        <div className={`${styles.collaborationDouble}`}>
          <div>
            <MyImage src={AbuDhabi} width="100" height="100" alt="AbuDhabi" />
          </div>
          <div>
            <MyImage src={MaharajaTrophy} width="100" height="100" alt="MaharajaTrophy" />
          </div>
        </div>
        <div className={`${styles.collaborationimage}`}>
          <MyImage src={RedBull} width="100" height="100" alt="RedBull" />
        </div>
      </div>
    </div>
  )
}

export default Collaboration
